module.exports = __webpack_public_path__ + "img/logo.2dced59d.png";